import { useState } from '#imports'
import { type ShallowRef, onBeforeUnmount, watchEffect } from 'vue'

import type { RevContainer } from '@ds/components/Container'

/**
 * We use this composable to force navigation the header to be hidden
 * when one of the sticky bars is visible.
 * @param topBarRef - A reference to the top bar element (RevContainer or HTMLDivElement).
 */
export const useForceHideHeader = (
  topBarRef: ShallowRef<
    Readonly<InstanceType<typeof RevContainer> | HTMLDivElement | null>
  >,
) => {
  const forceHidden = useState<boolean>('header-force-hidden')

  watchEffect(
    () => {
      // If element is removed from the DOM, we consider it as not visible.
      const elementToWatch =
        (topBarRef.value as InstanceType<typeof RevContainer>)?.$el ||
        (topBarRef.value as HTMLDivElement)

      const isElementToWatchVisible = Boolean(elementToWatch)

      forceHidden.value = isElementToWatchVisible
    },
    {
      flush: 'post',
    },
  )

  // Important: this ensures that the header visibility is reset to
  // its default behavior when the component is unmounted.
  onBeforeUnmount(() => {
    forceHidden.value = false
  })
}
